/* Mint-Tasks · page=detail: chỉ phần ngoài bộ lớp dùng chung của ../hr/profile.module.css. Màu chỉ var(--…). */
.cErr { background: var(--err-bg); color: var(--err); }
.cOk { background: var(--ok-bg); color: var(--ok); }
.cWarn { background: var(--warn-bg); color: var(--warn); }
.cPri { background: var(--pri-bg); color: var(--link); }
.cMute { background: var(--sub); color: var(--tx2); }
.kicker { font-size: 12px; color: var(--lb); }
.sumT { margin-top: 2px; font-size: 18px; font-weight: var(--fw-title); line-height: 1.3; }
.sumChips { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
.gate { margin-top: 12px; padding: 12px 14px; border-radius: 12px; }
.gate b { font-weight: var(--fw-title); }
.gate div { margin-top: 4px; font-size: 12px; color: var(--tx2); }
.gErr { background: var(--err-bg); }
.gErr b { color: var(--err); }
.gWarn { background: var(--warn-bg); }
.gWarn b { color: var(--warn); }
.gPri { background: var(--pri-bg); }
.gPri b { color: var(--link); }
.flag { display: flex; align-items: center; gap: 10px; min-height: 48px; border-top: 1px solid var(--line); }
.flag > span:last-child { min-width: 0; color: var(--tx2); }
.noteRow { display: flex; gap: 10px; min-height: 48px; align-items: center; border-top: 1px solid var(--line); }
.noteRow > span:first-child { width: 96px; flex-shrink: 0; font-size: 12px; color: var(--lb); }
.tl { display: flex; gap: 12px; }
.tlRail { display: flex; flex-direction: column; align-items: center; }
.tlDot { width: 12px; height: 12px; margin-top: 3px; border-radius: 50%; background: var(--line); }
.tlDot[data-st='d'] { background: var(--ok); }
.tlDot[data-st='c'] { background: var(--err); box-shadow: 0 0 0 3px var(--err-bg); }
.tlLine { flex-grow: 1; width: 2px; min-height: 26px; background: var(--line); }
.tlBody { padding-bottom: 12px; min-width: 0; }
.tlBody[data-st='c'] > div:first-child { font-weight: var(--fw-title); }
.tlBody > div:last-child { font-size: 12px; color: var(--lb); }
.lnk { color: var(--link); font-weight: var(--fw-title); }
.menu { position: absolute; right: 0; top: 46px; z-index: 30; min-width: 220px; padding: 6px; border-radius: 12px; background: var(--card); box-shadow: var(--pop); display: flex; flex-direction: column; }
.menu button { display: flex; align-items: center; height: 36px; padding: 0 10px; border: 0; border-radius: 9px; background: transparent; color: var(--tx); font: inherit; font-weight: var(--fw-label); text-align: left; cursor: pointer; white-space: nowrap; }
@media (hover: hover) { .menu button:hover { background: var(--sub); } }
.menuWrap { position: relative; }
